<template>
  <button
    type="button"
    tabindex="0"
    class="cursor-pointer dim btn btn-link text-70 inline-flex items-center"
    @keydown.enter.prevent="$emit('click')"
    @click.prevent="$emit('click')"
  >
    <font-awesome-icon v-once :icon="['far', 'trash-alt']" class="hover-primary" view-box="0 0 20 20" width="20" height="20" />
    <slot></slot>
  </button>
</template>

<script>
  export default {};
</script>
